goog.provide("shadow.js.shim.module$$mui$icons_material$BrokenImageOutlined$default");
shadow.js.shim.module$$mui$icons_material$BrokenImageOutlined$default = shadow.js.shim.module$$mui$icons_material$BrokenImageOutlined.default;
